export default __webpack_public_path__ + "static/runs-true-0430ecf53f3b13d0dcc36a4bc06ee2e3.svg";